import React from 'react';
import '../styles/benefits.css'
import AnimatedArrowButton from './AnimatedArrowButton';
import AnimationBox from '../animationBox';
import icon1 from '../assets/s1.png'
import icon4 from '../assets/s6.png'
import icon5 from '../assets/s5.png'


const Benefits = () => {


    return(<div className='robot-benefits'>
        
            <div className='benefits-inner'>
                <div className='benefits-box1'>
                    <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838', height:'33%',gap:'10px'}}>
                        <div className='benefits-icon'>
                            <img src={icon4} width='35px' height='35px' ></img>
                        </div>
                        <div className='benefits-msg' style={{textAlign:'left'}}>
                            <h4>Cost Efficiency</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Reduce operational costs by automating repetitive and labor-intensive tasks, enabling your team to focus on higher-value work.</p>
                        </div>
                    </div>
                    <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838', height:'33%',gap:'10px'}}>
                        <div className='benefits-icon'>
                            <img src={icon1} width='35px' height='35px' ></img>
                        </div>
                        <div className='benefits-msg' style={{textAlign:'left'}}>
                            <h4>Enhanced Productivity</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Achieve faster cycle times and improved output quality with precision-engineered robotic solutions designed for 24/7 operations.</p>
                        </div>
                    </div>
                    <div className='myservices' style={{display:'flex',padding:'25px', height:'33%',gap:'10px'}}>
                        <div className='benefits-icon'>
                            <img src={icon5} width='35px' height='35px' ></img>
                        </div>
                        <div className='benefits-msg' style={{textAlign:'left'}}>
                            <h4>Improved Safety</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Minimize workplace risks by deploying robots for hazardous or injury-prone tasks, ensuring a safer environment for your team.</p>
                        </div>
                    </div>

                </div>
                <div className='benefits-box2'>
                <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838', height:'15%',gap:'10px'}}>
                        
                            <h4 style={{color:'#FFD52B'}}>Benefits of Our Solution</h4>
                            
                </div>
                    <div className='myservices' style={{display:'flex',padding:'25px', height:'85%',gap:'10px',paddingTop:"60px"}}>
                        
                        <div className='my-benefits-msg' style={{textAlign:'left'}}>
                            <h1 style={{fontWeight:"600"}}>Why Choose Our Robotics Automation Services?</h1>
                            
                        </div>
                    </div>

                </div>

            </div>
        
    
    </div>);


}

export default Benefits ;